import { render } from "./ApplicationDetailsPopup.vue?vue&type=template&id=644fe8b7&scoped=true"
import script from "./ApplicationDetailsPopup.vue?vue&type=script&lang=js"
export * from "./ApplicationDetailsPopup.vue?vue&type=script&lang=js"

import "./ApplicationDetailsPopup.vue?vue&type=style&index=0&id=644fe8b7&scoped=true&lang=css"

import exportComponent from "/home/treim/code/trit/reclo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644fe8b7"]])

export default __exports__